import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Styles from './styles.module.css';
import { forgotPasswordRequest } from '../../api/index';
import envelopeWithCheckmarkImg from '../../../../shared/assets/icons/envelopeWithCheckmark.png';
import { useIntl } from 'react-intl';

export const VerifyEmailForgotPassword = () => {
	const intl = useIntl();
	const { search } = useLocation();
	const params = new URLSearchParams(search);
	const email = params.get('email');
	const [isResending, setIsResending] = useState(false);
	const [resendMessage, setResendMessage] = useState(null);
	const [countdown, setCountdown] = useState(0);

	// Countdown timer effect
	useEffect(() => {
		let timer;
		if (countdown > 0) {
			timer = setInterval(() => {
				setCountdown(prev => {
					if (prev <= 1) {
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
		}
		return () => {
			if (timer) clearInterval(timer);
		};
	}, [countdown]);

	const handleResend = async () => {
		if (!email || countdown > 0) return;

		setIsResending(true);
		setResendMessage(null);

		try {
			const result = await forgotPasswordRequest({ email });
			if (result.status === 200) {
				setResendMessage(
					intl.formatMessage({ id: 'VerifyEmailForgotPasswordValidationId1' }),
				);
				setCountdown(60); // Start 60 second countdown
			} else {
				setResendMessage(
					intl.formatMessage({ id: 'VerifyEmailForgotPasswordValidationId2' }),
				);
			}
		} catch (error) {
			setResendMessage(
				intl.formatMessage({ id: 'VerifyEmailForgotPasswordValidationId3' }),
			);
		} finally {
			setIsResending(false);
		}
	};

	return (
		<div className={Styles.container}>
			<div className={Styles.content}>
				<div className={Styles.iconContainer}>
					<img
						src={envelopeWithCheckmarkImg}
						alt='Email sent confirmation'
						className={Styles.envelopeIcon}
					/>
				</div>

				<h1 className={Styles.mainMessage}>
					{intl.formatMessage({ id: 'VerifyEmailForgotPasswordId1' })}
				</h1>

				<p className={Styles.subMessage}>
					{intl.formatMessage({ id: 'VerifyEmailForgotPasswordId2' })}
				</p>

				<div className={Styles.resendSection}>
					<p className={Styles.resendQuestion}>
						{intl.formatMessage({ id: 'VerifyEmailForgotPasswordId3' })}
					</p>
					<button
						className={Styles.resendLink}
						onClick={handleResend}
						disabled={isResending || countdown > 0}
					>
						{isResending
							? intl.formatMessage({ id: 'VerifyEmailForgotPasswordId4' })
							: countdown > 0
								? `${intl.formatMessage({ id: 'VerifyEmailForgotPasswordId5' })} (${countdown}s)`
								: intl.formatMessage({ id: 'VerifyEmailForgotPasswordId5' })}
					</button>
					{resendMessage && (
						<p
							className={
								resendMessage.includes('successfully')
									? Styles.successMessage
									: Styles.errorMessage
							}
						>
							{resendMessage}
						</p>
					)}
				</div>
			</div>
		</div>
	);
};
